export const DISCOUNT_PRICE_COLOR = '#F00';
export const INCREDIBLE_DISCOUNTS_PRICE_COLOR = '#399F26';

export const DEFAULT_ERROR_MESSAGE = 'Ai atins cantitatea maxima';
export const MAX_QUANTITY_REACHED_TOAST_ID = 'maxQuantityReachedToast';
